export default __webpack_public_path__ + "static/Vonny Wilianti-0026956a19136fcceba29a225d5efcef.webp";